import "./intro.css";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import RoundedButton from "../../atomic/RoundedButton";
import PhoneHeaderImage from "../../../assets/header-img-pars.png";
import { Container } from "@mui/system";
import BitcoinIcon from "../../../assets/bitcoin-4.png";
import Etcicon from "../../../assets/etc_4.png";
import DogeIcon from "../../../assets/doge_4.png";
import ChartIcon from "../../../assets/chart_icon_header.png";
import GiftPicture from "../../../assets/gift_pic.png";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import CurrencyShapeList from "../currencyshapelist/currencyshapelist";
import CurrencyList from "../currencylist/currencylist";
import CryptoCards from "../../cryptocards/cryptocards";

export function Intro() {
  const { t } = useTranslation();
  const [stat, setStat] = useState<any>({});

  useEffect(() => {
    fetch("https://parsianbit.com/stat.json").then((resp) => {
      resp.json().then((v) => setStat(v));
    });
  }, []);

  // @ts-ignore
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 0,
        mx: 0,
        px: 0,
        background: "#35003a",
      }}
    >
      <Grid
        container
        maxWidth="lg"
        sx={{ pt: 5, px: { xs: 1, md: 3 }, mx: "auto" }}
      >
        <Grid item md={6} xs={12} sx={{ my: "auto" }}>
          <Typography variant="h4" sx={{ mb: 2 }}>
            خرید و فروش امن و آسان
          </Typography>
          <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
            در پارسیان بیت ارزهای دیجیتال را با امنیت و به راحتی معامله کنید
          </Typography>
          <Stack direction="row" spacing={1}>
            <RoundedButton
              href="https://panel.parsianbit.com/trade"
              sx={{
                bgcolor: "#FF3DFF",
                minWidth: "100px",
                px: 4,
                py: 1.5,
                "&:hover": { bgcolor: "#FF3DFF" },
              }}
            >
              {" "}
              {t("start_now")}{" "}
            </RoundedButton>
          </Stack>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
          sx={{ mt: { xs: 2.5, md: 0 }, textAlign: "right" }}
        >
          <Box
            component="img"
            sx={{ maxWidth: "100%", maxHeight: "auto" }}
            src={PhoneHeaderImage}
          />
        </Grid>
      </Grid>
      <Box sx={{ position: "relative" }}>
        <Container sx={{ px: { xs: 2 } }}>
          <Box
            sx={{
              position: "fixed",
              left: { xs: "unset", sm: "2.5%" },
              right: { xs: "4%", sm: "unset" },
              bottom: { xs: "2.5%", md: "31%", sm: "10%" },
              zIndex: "150",
            }}
          >
            <Link to="/referral">
              <img src={GiftPicture} alt="icon" width="auto" />
            </Link>
          </Box>
          <Box display={{ xs: "none", md: "block" }}>
            <CurrencyShapeList />
          </Box>
          <Box display={{ xs: "block", md: "none" }}>
            <CryptoCards />
          </Box>
        </Container>
      </Box>
    </Paper>
  );
}
